module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [(!_vm.registrationSuccess) ? _c('div', {
    staticClass: "section__copy"
  }, [_c('h2', [_vm._v("Registration")]), _vm._v(" "), _c('p', {}, [_vm._v("Thank you for participating. The videos you upload will be added to the video database and will be used to populate britaintakeabow.org")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-about'
      }
    }
  }, [_vm._v("Find out more about the project")])], 1), _vm._v(" "), _c('p', [_vm._v("Please complete the fields below:")])]) : _vm._e(), _vm._v(" "), (!_vm.registrationSuccess) ? _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.firstName),
      expression: "auth.firstName"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.firstName.$error
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.auth.firstName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.firstName = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('firstName')
      }]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.lastName),
      expression: "auth.lastName"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.lastName.$error
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.auth.lastName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.lastName = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('lastName')
      }]
    }
  })]), _vm._v(" "), (_vm.$v.auth.firstName.$error || _vm.$v.auth.lastName.$error) ? _c('span', {
    staticClass: "form__help form__help--error"
  }, [_vm._v("\n            These fields are required.\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.username),
      expression: "auth.username"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.username.$error
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Your email address"
    },
    domProps: {
      "value": (_vm.auth.username)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.username = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('username')
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "form__help"
  }, [_vm._v("You'll need to confirm that this email address belongs to you")]), _vm._v(" "), (_vm.$v.auth.username.$error) ? _c('span', {
    staticClass: "form__help form__help--error"
  }, [_vm._v("\n            This field is required. Please use a valid email address.\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "form__help"
  }, [_vm._v("(required when you upload your videos)")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.password),
      expression: "auth.password"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.password.$error
    },
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.auth.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.password = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('password')
      }]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.passwordConfirm),
      expression: "auth.passwordConfirm"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.auth.passwordConfirm.$error
    },
    attrs: {
      "name": "passwordConfirm",
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.auth.passwordConfirm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.passwordConfirm = $event.target.value
      }, function($event) {
        _vm.handleFieldInput('passwordConfirm')
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "form__help"
  }, [_vm._v("Use 8 or more characters with a mix of letters, numbers & symbols")]), _vm._v(" "), (_vm.$v.auth.password.$error || _vm.$v.auth.passwordConfirm.$error) ? _c('span', {
    staticClass: "form__help form__help--error"
  }, [_vm._v("\n            Your password must be 8 or more characters. Password confirmation must match password.\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "links"
    }
  }, [_vm._v("Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form__input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.credit),
      expression: "auth.credit"
    }],
    staticClass: "form__input",
    attrs: {
      "name": "links",
      "type": "text",
      "placeholder": "Separate urls with commas"
    },
    domProps: {
      "value": (_vm.auth.credit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.credit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "form__help"
  }, [_vm._v("We'll replace web links, twitter handles with clickable links")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('button', {
    staticClass: "button form__submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Register\n          ")]), _vm._v(" "), (_vm.authMessage) ? _c('p', {
    staticClass: "form__link mr-2"
  }, [_vm._v(_vm._s(_vm.authMessage))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.registrationSuccess) ? _c('div', [_c('h2', [_vm._v("Registration successful")]), _vm._v(" "), _c('p', [_vm._v("Thank you for registering, your account is now awaiting approval. Once approved, you will be notified by email and will be able to log in and upload videos.")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "form__link",
    attrs: {
      "to": 'login'
    }
  }, [_vm._v("Login")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section__copy"
  }, [_c('span', {
    staticClass: "form__help"
  }, [_vm._v("We'll credit you at the end of the video. Please add links to your website, Twitter, Facebook profile, Instagram etc below")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5efaca4","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/register.vue
// module id = 233
// module chunks = 1